/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedServiceListAdmin } from './PaginatedServiceListAdmin'
import {
  PaginatedServiceListAdminFromJSON,
  PaginatedServiceListAdminFromJSONTyped,
  PaginatedServiceListAdminToJSON,
} from './PaginatedServiceListAdmin'

/**
 *
 * @export
 * @interface EnvelopedServiceListServiceListAdmin
 */
export interface EnvelopedServiceListServiceListAdmin {
  /**
   *
   * @type {PaginatedServiceListAdmin}
   * @memberof EnvelopedServiceListServiceListAdmin
   */
  body: PaginatedServiceListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedServiceListServiceListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedServiceListServiceListAdmin interface.
 */
export function instanceOfEnvelopedServiceListServiceListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedServiceListServiceListAdminFromJSON(
  json: any,
): EnvelopedServiceListServiceListAdmin {
  return EnvelopedServiceListServiceListAdminFromJSONTyped(json, false)
}

export function EnvelopedServiceListServiceListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedServiceListServiceListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedServiceListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedServiceListServiceListAdminToJSON(
  value?: EnvelopedServiceListServiceListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedServiceListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
